(() => {
  const initialize = () => {
    const main = document.querySelector('[data-lura-home-main]');
    if (!main || main.dataset.bound) return;
    main.dataset.bound = 'true';
    const revealHash = () => {
      const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (target?.tagName === 'DETAILS') target.open = true;
    };
    revealHash();
    window.addEventListener('hashchange', revealHash);
    let returnFocus;
    document.querySelectorAll('.lura-home [data-open]').forEach(button => button.addEventListener('click', () => {
      const dialog = main.querySelector('#' + button.dataset.open);
      if (!dialog) return;
      const active = main.querySelector('dialog[open]');
      if (!active) returnFocus = button;
      if (active) active.close();
      dialog.showModal();
      const film = dialog.querySelector('video');
      if (film) {
        if (!film.getAttribute('src')) film.src = film.dataset.src;
        film.play().catch(() => {});
      }
    }));
    main.querySelectorAll('dialog').forEach(dialog => {
      dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        dialog.querySelectorAll('video').forEach(video => { video.pause(); video.currentTime = 0; });
        if (!main.querySelector('dialog[open]') && returnFocus?.isConnected) returnFocus.focus(); });
    });
    main.querySelectorAll('video').forEach(video => video.addEventListener('play', () => main.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); })));
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

